import type { IconData } from '../../types';

export const data: IconData = {
  o: '<path d="M200-640h560v-80H200v80Zm0 0v-80 80Zm0 560q-33 0-56-23t-24-57v-560q0-33 24-56t56-24h40v-80h80v80h320v-80h80v80h40q33 0 57 24t23 56v227q-19-9-39-15t-41-9v-43H200v400h252q7 22 17 42t22 38H200Zm520 40q-83 0-141-58t-59-142q0-83 59-141t141-59q83 0 142 59t58 141q0 83-58 142T720-40Zm67-105 28-28-75-75v-112h-40v128l87 87Z"/>',
  f: '<path d="M200-80q-33 0-56-23t-24-57v-560q0-33 24-56t56-24h40v-80h80v80h320v-80h80v80h40q33 0 57 24t23 56v187q0 17-11 29t-29 11q-17 0-28-11t-12-29v-27H200v400h232q17 0 29 12t11 28q0 17-11 29t-29 11H200Zm520 40q-83 0-141-58t-59-142q0-83 59-141t141-59q83 0 142 59t58 141q0 83-58 142T720-40Zm67-105 28-28-75-75v-112h-40v128l87 87Z"/>',
  rao: { fill: '#e8eaed' },
  raf: { fill: '#e8eaed' },
};

export default data;
